import { render, staticRenderFns } from "./Preaspirantes.vue?vue&type=template&id=f35b3c30"
import script from "./Preaspirantes.vue?vue&type=script&lang=js"
export * from "./Preaspirantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports